<template>
  <base-card tabled>
    <base-table>
      <thead>
        <tr>
          <th>Admin</th>
          <th>Action</th>
          <th>Date</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(log, key) in logs.rows" :key="key">
          <td>
            {{ log.user.profile.firstName }} {{ log.user.profile.lastName }}
            <br>
            {{ log.user.email }}
          </td>
          <td>{{ log.log }}</td>
          <td>{{ $dates.toDateTime(log.createdAt) }}</td>
          <td>
            <base-button secondary small @click="view(log)">
              View Data
            </base-button>
          </td>
        </tr>
      </tbody>
    </base-table>
    <base-modal large target="viewLog" title="View Log">
      <pre>{{ display }}</pre>
      <template v-slot:footer>
        <base-button @click="$modal.close('#viewLog')">Close</base-button>
      </template>
    </base-modal>
  </base-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'InvestmentAudit',

  data: () => ({
    display: null,
    logs: []
  }),

  created () {
    this.get()
  },

  computed: {
    ...mapState({
      investment: store => store.core.investments.entity
    })
  },

  methods: {
    entities () {
      const entities = [this.investment._id]

      this.investment.documents.forEach(document => entities.push(document._id))
      this.investment.rounds.forEach(round => entities.push(round._id))

      return entities
    },

    get () {
      this.filter({
        services: [
          'documents',
          'investment-funding',
          'investments'
        ],
        entities: this.entities()
      })
        .then(res => {
          this.logs = res
        })
        .catch(err => this.$flash.failure(err))
    },

    view (log) {
      this.display = log.data

      this.$modal.show('#viewLog')
    },

    ...mapActions({
      filter: 'core/admin-audit/filter'
    })
  }
}
</script>
